import { Layout } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { fetchCurrentUser } from "../api/user.js";

const { Content } = Layout;

const BASE = "/host";

// 如果浮动按钮挡住了页面左下角内容，把这个值改成 88 左右即可（按钮高度 52 + 边距）
const CONTENT_BOTTOM_PADDING = 16;

const items = [
  { key: "rentCollection", label: "出租合约" },
  { key: "dictManage", label: "字典管理" },
  { key: "WaterElectricityMeterRecord", label: "水电抄表" },
  { key: "assetCategory", label: "资产类别" },
  { key: "purchaseRecord", label: "采购记录" },
  { key: "idle", label: "闲置房产" },
  { key: "asset", label: "资产管理" },
  { key: "assetTransaction", label: "资产交易" },
  { key: "list", label: "房源列表" },
  { key: "expense", label: "费用管理" },
];

// 找出当前路径对应的菜单 key（精确匹配或子页面匹配，取最长的）
function getActiveKey(pathname) {
  const path = pathname.replace(/\/+$/, "");
  let active = null;
  for (const { key } of items) {
    const full = `${BASE}/${key}`;
    if (path === full || path.startsWith(full + "/")) {
      if (!active || key.length > active.length) active = key;
    }
  }
  return active;
}

const css = `
.ant-input-number-handler-wrap { display: none; }
.ml-fab {
  position: fixed;
  left: 16px;
  bottom: calc(16px + env(safe-area-inset-bottom, 0px));
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.75);
  background: rgba(255, 255, 255, 0.55);
  -webkit-backdrop-filter: blur(14px) saturate(160%);
  backdrop-filter: blur(14px) saturate(160%);
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.18);
  color: #1e293b;
  font-family: "Songti SC", "STKaiti", "KaiTi", "Noto Serif SC", serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
  padding: 0;
  cursor: pointer;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.85;
  transition: opacity .2s, transform .25s, background .2s;
  -webkit-tap-highlight-color: transparent;
}
.ml-fab:hover, .ml-fab.open { opacity: 1; }
.ml-fab:active { transform: scale(.94); }
.ml-fab span { display: inline-block; transition: transform .35s cubic-bezier(.2,.8,.2,1); }
.ml-fab.open span { transform: rotate(90deg); }

.ml-mask {
  position: fixed;
  inset: 0;
  z-index: 998;
  background: rgba(15, 23, 42, 0.12);
  opacity: 0;
  pointer-events: none;
  transition: opacity .2s;
}
.ml-mask.open { opacity: 1; pointer-events: auto; }

.ml-panel {
  position: fixed;
  left: 16px;
  bottom: calc(16px + 52px + 12px + env(safe-area-inset-bottom, 0px));
  width: min(320px, calc(100vw - 32px));
  max-height: calc(100vh - 140px);
  overflow-y: auto;
  padding: 12px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.75);
  background: rgba(255, 255, 255, 0.6);
  -webkit-backdrop-filter: blur(20px) saturate(160%);
  backdrop-filter: blur(20px) saturate(160%);
  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.22);
  z-index: 999;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  transform-origin: bottom left;
  transform: scale(.88) translateY(8px);
  opacity: 0;
  visibility: hidden;
  transition: transform .25s cubic-bezier(.2,.8,.2,1), opacity .2s, visibility 0s .25s;
}
.ml-panel.open {
  transform: none;
  opacity: 1;
  visibility: visible;
  transition: transform .25s cubic-bezier(.2,.8,.2,1), opacity .2s, visibility 0s;
}

.ml-item {
  border: none;
  background: rgba(255, 255, 255, 0.45);
  color: #1e293b;
  font-size: 15px;
  padding: 13px 8px;
  border-radius: 12px;
  cursor: pointer;
  text-align: center;
  transition: background .15s, color .15s, transform .1s;
  -webkit-tap-highlight-color: transparent;
}
.ml-item:hover { background: rgba(255, 255, 255, 0.8); }
.ml-item:active { transform: scale(.96); }
.ml-item.active {
  background: rgba(22, 119, 255, 0.16);
  color: #1677ff;
  font-weight: 600;
}

/* 不支持毛玻璃的浏览器：提高不透明度保证可读 */
@supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {
  .ml-fab { background: rgba(255, 255, 255, 0.92); }
  .ml-panel { background: rgba(255, 255, 255, 0.96); }
}

/* 夜间模式：深色玻璃 */
@media (prefers-color-scheme: dark) {
  .ml-fab {
    background: rgba(30, 41, 59, 0.55);
    border-color: rgba(255, 255, 255, 0.18);
    color: #e2e8f0;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.45);
  }
  .ml-mask { background: rgba(0, 0, 0, 0.35); }
  .ml-panel {
    background: rgba(30, 41, 59, 0.6);
    border-color: rgba(255, 255, 255, 0.16);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.55);
  }
  .ml-item { background: rgba(255, 255, 255, 0.08); color: #e2e8f0; }
  .ml-item:hover { background: rgba(255, 255, 255, 0.16); }
  .ml-item.active { background: rgba(22, 119, 255, 0.35); color: #91caff; }
  @supports not ((backdrop-filter: blur(1px)) or (-webkit-backdrop-filter: blur(1px))) {
    .ml-fab { background: rgba(30, 41, 59, 0.95); }
    .ml-panel { background: rgba(30, 41, 59, 0.97); }
  }
}
`;

export default function ManageLayout() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const activeKey = getActiveKey(location.pathname);

  useEffect(() => {
    fetchCurrentUser().then((res) => {
      localStorage.setItem("user", JSON.stringify(res.data));
    });
  }, []);

  // Esc 关闭
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  const go = (key) => {
    navigate(`${BASE}/${key}`);
    setOpen(false);
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <style>{css}</style>

      <Layout>
        <Content
          style={{
            // padding: 16,
            paddingBottom: CONTENT_BOTTOM_PADDING,
            background: "#f5f5f5",
          }}
        >
          <Outlet />
        </Content>
      </Layout>

      {/* 点击面板外部关闭 */}
      <div
        className={`ml-mask${open ? " open" : ""}`}
        onClick={() => setOpen(false)}
      />

      <nav className={`ml-panel${open ? " open" : ""}`} aria-hidden={!open}>
        {items.map((item) => (
          <button
            key={item.key}
            type="button"
            tabIndex={open ? 0 : -1}
            className={`ml-item${item.key === activeKey ? " active" : ""}`}
            onClick={() => go(item.key)}
          >
            {item.label}
          </button>
        ))}
      </nav>

      <button
        type="button"
        className={`ml-fab${open ? " open" : ""}`}
        aria-label="打开菜单"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <span>房</span>
      </button>
    </Layout>
  );
}
